import React, { FunctionComponent } from 'react';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { FeatureFlag } from '../../../../services/models/feature-flags';
import { classNames } from '../../../../utils/class-names';
import { VectorIcon } from '../../../VectorIcon';

export enum AddBriefWizardStep {
  DefineScreen,
  RefineScreen,
  NameScreen,
}

interface Props {
  step: AddBriefWizardStep;
  isWorking: boolean;
}

const NewBriefWizardStepper: FunctionComponent<Props> = ({ step, isWorking }) => {
  const newReportShowPreviewScreenFlag = useFeatureFlag(FeatureFlag.NewReportShowPreviewScreen);

  const steps = newReportShowPreviewScreenFlag
    ? ['Topic', 'Preview', 'Done']
    : ['Topic', 'Refine', 'Done'];

  return (
    <div className="sticky top-0 z-[850] flex w-full flex-col items-center border-b border-gray-200 bg-white px-4 py-4">
      <div className="w-full max-w-3xl pb-2.5 text-center">
        <h1 className="my-4 text-xl font-bold tracking-wide text-gray-900">
          {step === AddBriefWizardStep.DefineScreen && (
            <span>Tell us what you want to monitor</span>
          )}
          {step === AddBriefWizardStep.RefineScreen && (
            <span>
              Monitor like a Pro! <VectorIcon file="rocket" />
            </span>
          )}
          {step === AddBriefWizardStep.NameScreen && (
            <span>
              That was easy, wasn’t it? <VectorIcon file="happy" />
            </span>
          )}
        </h1>
      </div>

      <nav aria-label="Progress" className="w-full max-w-3xl">
        <ol role="list" className="flex gap-4">
          {steps.map((item, i) => {
            const isComplete = i <= step;
            const isCurrent = i === step;
            const isWorkingStep = isCurrent && isWorking;

            return (
              <li key={item} className="flex flex-1 flex-col gap-2">
                <div
                  className={classNames(
                    'h-2.5 w-full rounded-full',
                    isComplete ? 'bg-secondary' : 'bg-secondary/30',
                    isWorkingStep ? 'animate-pulse' : ''
                  )}
                />
                <span
                  aria-current={isCurrent ? 'step' : undefined}
                  className={classNames(
                    'text-sm',
                    isCurrent ? 'font-bold text-gray-900' : 'font-normal text-gray-500'
                  )}
                >
                  {i + 1}. {item}
                </span>
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default NewBriefWizardStepper;
